import { render, staticRenderFns } from "./BusinessTv.vue?vue&type=template&id=39b1e45c&scoped=true&"
import script from "./BusinessTv.vue?vue&type=script&lang=ts&"
export * from "./BusinessTv.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessTv.vue?vue&type=style&index=0&id=39b1e45c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b1e45c",
  null
  
)

export default component.exports